module.exports = __webpack_public_path__ + "static/media/timer.2a52d1fa.svg";